import { render, staticRenderFns } from "./CPrison.vue?vue&type=template&id=04d2e8f1"
import script from "./CPrison.vue?vue&type=script&lang=js"
export * from "./CPrison.vue?vue&type=script&lang=js"
import style0 from "./CPrison.vue?vue&type=style&index=0&id=04d2e8f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports